const styles = () => ({
    container: {
        overflow: 'hidden',
        paddingTop: '20px',
        paddingBottom: '20px',
        '& h3': {
            fontWeight: 'bold',
            color: '#666',
            marginBottom: '5px',
        },
        '& p': {
            margin: '0',
        },
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
